import React from "react";
import moment from 'moment'
import classnames from "classnames";
// JavaScript library that creates a callendar with events
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import interaction from "@fullcalendar/interaction";
import fiLocale from '@fullcalendar/core/locales/fi';
// react component used to create sweet alerts
import ReactBSAlert from "react-bootstrap-sweetalert";
// reactstrap components
import {
  Card,
  CardBody,
} from "reactstrap";

import CalendarEvent from "components/CalendarEvent/CalendarEvent"
import { Button, Modal } from "stories/components"
import { Input } from "stories/forms"
import { Col, Row } from "stories/layout"
// api
import { httpGetCalendar } from "services/calendar";
import { httpGetCalendarEvents } from "services/calendarEvents";

import "./Calendar.css";

let calendar;

window.mobilecheck = function() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

class Fullcalendar extends React.Component {
  state = {
    events: this.props.events,
    alert: null
  };
  componentDidMount() {
    this.createCalendar(this.props?.user?.key);
    this.getMyCalendar(this.props?.user?.id);
  }
  getMyCalendar = (userId) => {
    httpGetCalendar({user_id: userId}).then(res => {
      if (res && res.length > 0) {
        this.setState({
          calendarKey: res[0].key
        });
      }
    })
  }
  createCalendar = (userKey) => {
    calendar = new Calendar(this.refs.calendar, {
      locales: [ fiLocale, ],
      locale: 'fi',
      headerToolbar: false,
      plugins: [interaction, dayGridPlugin],
      // defaultView: "dayGridMonth",
      // defaultView: window.mobilecheck() ? "basicDay" : "dayGridMonth",
      // initialView: "dayGridDay",
      initialView: "dayGridMonth", // dayGridWeek
      selectable: true,
      selectHelper: true,
      editable: false,
      showNonCurrentDates: false,
      selectLongPressDelay: 0,
      events: (info, successCallback, failureCallback) => {
        const params = {
          user_key: userKey,
        }
        
        var today = new Date();
        var y = today.getFullYear();
        var m = today.getMonth();
        var d = today.getDate();
        
        
        httpGetCalendarEvents(params).then(res => {
          let _events = [];
          res && res.map(ev => {
            _events.push({
              id: ev.id,
              key: ev.key,
              title: moment(ev.timestart).format("HH:mm"),
              start: ev.timestart, // moment new Date(y, m, 1)
              end: ev.timeend,
              allDay: true,
              className: "bg-red",
              description: ev.description,
            })
          })
          
          successCallback(_events);
        })
        
        let current_month = moment(info?.start).format('MMMM YYYY');
        this.setState({
          currentDate: current_month
        });
      },
      // Add new event
      select: info => {
        this.setState({
          modalAdd: true, // MANUALLY DISABLED true
          startDate: info.startStr,
          endDate: info.endStr,
          radios: "bg-info"
        });
      },
      // Edit calendar event action
      eventClick: ({ event }) => {
        this.setState({
          modalChange: true, // MANUALLY DISABLED true
          eventId: event.id,
          eventKey: event.extendedProps?.key,
          eventTitle: event.title,
          eventDescription: event.extendedProps.description,
          radios: "bg-info",
          event: event
        });
      },
    });
    calendar.render();
    this.setState({
      currentDate: calendar.view.title
    });
  };
  changeView = newView => {
    calendar.changeView(newView);
  };
  addNewEvent = () => {
    var newEvents = this.state.events;
    newEvents.push({
      title: this.state.eventTitle,
      start: this.state.startDate,
      end: this.state.endDate,
      className: this.state.radios,
      id: this.state.events[this.state.events.length - 1] + 1
    });
    calendar.addEvent({
      title: this.state.eventTitle,
      start: this.state.startDate,
      end: this.state.endDate,
      className: this.state.radios,
      id: this.state.events[this.state.events.length - 1] + 1
    });
    this.setState({
      modalAdd: false,
      events: newEvents,
      startDate: undefined,
      endDate: undefined,
      radios: "bg-info",
      eventTitle: undefined
    });
  };
  changeEvent = () => {
    var newEvents = this.state.events.map((prop, key) => {
      if (prop.id + "" === this.state.eventId + "") {
        this.state.event.remove();
        calendar.addEvent({
          ...prop,
          title: this.state.eventTitle,
          className: this.state.radios,
          description: this.state.eventDescription
        });
        return {
          ...prop,
          title: this.state.eventTitle,
          className: this.state.radios,
          description: this.state.eventDescription
        };
      } else {
        return prop;
      }
    });
    this.setState({
      modalChange: false,
      events: newEvents,
      radios: "bg-info",
      eventTitle: undefined,
      eventDescription: undefined,
      eventId: undefined,
      event: undefined
    });
  };
  deleteEventSweetAlert = () => {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() =>
            this.setState({
              alert: false,
              radios: "bg-info",
              eventTitle: undefined,
              eventDescription: undefined,
              eventId: undefined
            })
          }
          onCancel={() => this.deleteEvent()}
          confirmBtnCssClass="btn-secondary"
          cancelBtnBsStyle="danger"
          confirmBtnText="Cancel"
          cancelBtnText="Yes, delete it"
          showCancel
          btnSize=""
        >
          You won't be able to revert this!
        </ReactBSAlert>
      )
    });
  };
  deleteEvent = () => {
    var newEvents = this.state.events.filter(
      prop => prop.id + "" !== this.state.eventId
    );
    this.state.event.remove();
    this.setState({
      alert: (
        <ReactBSAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="Success"
          onConfirm={() => this.setState({ alert: null })}
          onCancel={() => this.setState({ alert: null })}
          confirmBtnBsStyle="primary"
          confirmBtnText="Ok"
          btnSize=""
        >
          A few words about this sweet alert ...
        </ReactBSAlert>
      ),
      modalChange: false,
      events: newEvents,
      radios: "bg-info",
      eventTitle: undefined,
      eventDescription: undefined,
      eventId: undefined,
      event: undefined
    });
  };
  handleOnEventCreated = () => {
    calendar.refetchEvents()
    this.setState({ modalAdd: false });
  }
  handleOnEventUpdated = () => {
    calendar.refetchEvents()
    this.setState({ modalChange: false });
  }
  handleEventClose = () => {
    this.setState({
      modalAdd: false,
      modalChange: false
    });
  }
  render() {
    return (
      <>
        {this.state.alert}
        <Card className="card-calendar">
        
          <Row>
            <Col className="mb-3"></Col>
            <Col className="mb-3 text-center">{this.state.currentDate}</Col>
            <Col className="mb-3 text-right">
              
              <Button
                className="fullcalendar-btn-next btn-neutral"
                color="default"
                onClick={() => {
                  calendar.prev();
                }}
                size="sm"
              >
                <i className="fas fa-angle-left" />
              </Button>
              
              <Button
                className="fullcalendar-btn-prev btn-neutral"
                color="default"
                onClick={() => {
                  calendar.next();
                }}
                size="sm"
              >
                <i className="fas fa-angle-right" />
              </Button>
            </Col>
          </Row>
          
          <CardBody className="p-0">
            <div
              className="calendar"
              ref="calendar"
            />
          </CardBody>
        </Card>
        
        <Modal size="modal-lg" isOpen={this.state.modalAdd} toggleModal={() => this.setState({ modalAdd: false })} title="Uusi tapahtuma">
          <CalendarEvent user={this.props.user} calendarKey={this.state.calendarKey} eventDate={this.state.startDate} handleResolve={this.handleOnEventCreated} handleReject={this.handleEventClose} />
        </Modal>
        
        
        <Modal
          size="modal-lg"
          isOpen={this.state.modalChange}
          toggle={() => this.setState({ modalChange: false })}
          className="modal-dialog-centered modal-secondary"
        >
          <CalendarEvent eventKey={this.state.eventKey} handleResolve={this.handleOnEventUpdated} handleReject={this.handleEventClose} />
        </Modal>
      </>
    );
  }
}

export default Fullcalendar;
